﻿import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { CONFIG } from '../../core/config';
import { catchError, finalize } from 'rxjs/operators';
import { ExceptionService } from '../../core/services/exception.service';
import { LoginType } from '../../core/models/administration/system-parameters/login-type';
import { SpinnerService } from '../../core/spinner/spinner.service';
import { RegistrationFields } from '../../core/models/administration/system-parameters/registration-fields';
import { ConfirmationRegistrationType } from '../../core/models/administration/system-parameters/confirmation-registration-type';
import { ConfigurationParameter } from '../../core/models/administration/complaint-configuration/parameter-configuration';

@Injectable({
    providedIn: 'root'
})
export class SystemParametersService {

    constructor(private _http: HttpClient,
        private _exceptionService: ExceptionService,
        private _spinnerService: SpinnerService) { }

    getAllConfirmationRegistrationTypes(langID: number): Observable<ConfirmationRegistrationType[]> {
        this._spinnerService.show();
        return this._http.get<ConfirmationRegistrationType[]>(CONFIG.baseUrls.admin.systemParameters.getAllConfirmationRegistrationTypes + langID.toString())
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

    saveConfirmationRegistrationTypeActivity(data: ConfirmationRegistrationType): Observable<any> {
        this._spinnerService.show();
        return this._http.post<any>(CONFIG.baseUrls.admin.systemParameters.saveConfirmationRegistrationTypeActivity, data)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

    getAllLoginTypes(langID: number): Observable<LoginType[]> {
        this._spinnerService.show();
        return this._http.get<LoginType[]>(CONFIG.baseUrls.admin.systemParameters.getAllLoginTypes  + langID.toString())
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

    saveLoginTypeActivity(data: LoginType): Observable<any> {
        this._spinnerService.show();
        return this._http.post<any>(CONFIG.baseUrls.admin.systemParameters.saveLoginTypeActivity, data)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

    getAllRegistrationFields(langID: number): Observable<RegistrationFields[]> {
        this._spinnerService.show();
        return this._http.get<RegistrationFields[]>(CONFIG.baseUrls.admin.systemParameters.getAllRegistrationFields + langID)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

    saveRegistrationFields(data: RegistrationFields): Observable<any> {
        this._spinnerService.show();
        return this._http.post<any>(CONFIG.baseUrls.admin.systemParameters.saveRegistrationFields, data)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

    getAllComplaintParameters(langID: number): Observable<ConfigurationParameter[]> {
        this._spinnerService.show();
        return this._http.get<ConfigurationParameter[]>(CONFIG.baseUrls.admin.systemParameters.getAllComplaintParameters + langID)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

    getComplaintParameterByID(id: number, langID: number): Observable<ConfigurationParameter> {
        this._spinnerService.show();
        return this._http.get<ConfigurationParameter>(CONFIG.baseUrls.admin.systemParameters.GetComplaintParameterByID + id + "/" + langID)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

    saveConfigurationParameter(data: ConfigurationParameter): Observable<any> {
        this._spinnerService.show();
        return this._http.post<any>(CONFIG.baseUrls.admin.systemParameters.SaveConfigurationParameter, data)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }
}